import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { AppGlobalData } from 'src/app/core/appglobaldata';
import { Observable } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { SummaryForSupplierDTO } from 'src/app/models/summary-for-supplier-dto';
import { SummaryForPEDTO } from 'src/app/models/summary-for-pe-dto';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { TslDonutChartOptions } from '@tesla/ng-tds';
import { ChartProposalStatus } from 'src/app/core/constantEnums';
import { Constants } from 'src/app/core/constants';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { StorageSettings } from 'src/app/utils/storage.settings';
import Helper from 'src/app/core/utility/helper';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BasePage implements OnInit, AfterViewInit {
    chart = [];
    summaryForSupplierDTO: SummaryForSupplierDTO = new SummaryForSupplierDTO();
    summaryForPEDTO: SummaryForPEDTO = new SummaryForPEDTO();
    appGlobalData: AppGlobalData;
    IsEmployee$: Observable<boolean>;
    IsAdmin$: Observable<boolean>;
    IsSupplier$: Observable<boolean>;
    notificationMessage: string;
    supplierChartData: Array<any> = [];
    peChartData: Array<any> = [];
    supplierDonutOptions: TslDonutChartOptions = {
        width: 550,
        height: 550,
        isAnimated: true,
        externalRadius: 200,
        internalRadius: 120,
        actionLinks: true,
        displayValue: true,
        colorSchema: ['rgb(226, 69, 129)', 'rgb(121, 73, 157)', 'rgb(46, 73, 148)', 'rgb(255, 88, 97)' , 'rgb(255, 153, 0)']
    };

    engDonutOptions: TslDonutChartOptions = {
        width: 550,
        height: 550,
        isAnimated: true,
        externalRadius: 200,
        internalRadius: 120,
        actionLinks: true,
        displayValue: true,
        colorSchema: ['rgb(121, 73, 157)', 'rgb(255, 88, 97)', 'rgb(46, 73, 148)']
    };
    chartSpinner: boolean = true;
    noProposals: boolean = false;
    locStorage = Constants.localStorageKeys;

    constructor(
        localstorageService: LocalstorageService,
        private appGlobalDataService: AppGlobalDataService,
        private dataService: DataService,
        logger: NGXLogger,
        appSettings: AppSettings,
        public storageSettings: StorageSettings,
        private router: Router
    ) {
        super(localstorageService, logger, appSettings);
        this.router.events.subscribe((e: any) => {
            this.setFlags();
        });
    }

    ngOnInit() {
        // this.notificationMessageSetter();
        // TMS-4762 - don't show chart for readonly user but take directly to search parts
        if (this.IsReadOnlyUser) {
            this.router.navigate(['/searchpartpe']);
        }

        // TMS-17419 Errors immediately after logging in. Consolidate user logging validation.
        this.appGlobalDataService.currentSupplierCode.subscribe(data => {
            if (data && 
                this.IsSupplier &&
                Helper.CheckSupplierLogin(this.storageSettings)) {
                this.getSummaryForSupplier();
            }
        });

        this.appGlobalDataService.IsSupplier.subscribe(data => {
            if (data &&
                Helper.CheckSupplierLogin(this.storageSettings)) {
                this.getSummaryForSupplier();
            }
        });

        this.appGlobalDataService.IsEmployee.subscribe(data => {
            if (data && 
                this.IsEmployee &&
                Helper.CheckEmployeeLogin(this.storageSettings)) {
                if (this.IsLoggedInAsSupplier) {
                    this.getSummaryForSupplier();
                } else {
                    this.getSummaryForPE();
                }
            }
        });
    }

    // Obtain the message from services invoked by the backend
    notificationMessageSetter() {
        this.dataService
            .getNotificationMessage()
            .subscribe(
                a => (this.notificationMessage = a['Data']['ParameterValue'])
            );
    }

    goToSupplierProposal(event: any) {
        if (event.id === ChartProposalStatus.Pending) {
            this.router.navigate(['/Pendingproposals']);
        }

        if (event.id === ChartProposalStatus.Rejected) {
            this.router.navigate(['/Rejectedproposals']);
        }
        // TMS-17427 Add Submitted proposal view UI for suppliers
        if (event.id === ChartProposalStatus.Submitted) {
            this.router.navigate(['/Submittedproposals'])
        }
        // TMS-17428 Add Approved proposal view UI for suppliers
        if (event.id === ChartProposalStatus.Approved) {
            this.router.navigate(['/Approvedproposals'])
        }

        if (event.id === ChartProposalStatus.Incomplete) {
            this.router.navigate(['/Incompleteproposals'])
        }
    }

    getSummaryForSupplier() {
        this.chartSpinner = true;
        this.notificationMessageSetter();
        this.dataService.getSummaryForSupplier().subscribe((response: any) => {
            this.chartSpinner = false;
            if (response != null) {
                this.noProposals = false;
                this.summaryForSupplierDTO = response.Data;
                this.appGlobalDataService.updateMenuSupplierBadges(this.summaryForSupplierDTO);
                this.localstorageService.store(this.locStorage.CountBadges, this.summaryForSupplierDTO);
                this.supplierChartData = [
                    {
                        label: 'Pending',
                        value: this.summaryForSupplierDTO.Pending || 0,
                        id: ChartProposalStatus.Pending
                    },
                    {
                        label: 'Submitted',
                        value: this.summaryForSupplierDTO.Submitted || 0,
                        id: ChartProposalStatus.Submitted
                    },
                    {
                        label: 'Approved',
                        value: this.summaryForSupplierDTO.Approved || 0,
                        id: ChartProposalStatus.Approved
                    },
                    {
                        label: 'Rejected',
                        value: this.summaryForSupplierDTO.Rejected || 0,
                        id: ChartProposalStatus.Rejected
                    },                    
                    {
                        label: 'Incomplete',
                        value: this.summaryForSupplierDTO.Incomplete || 0,
                        id: ChartProposalStatus.Incomplete
                    }

                ];

                if (this.supplierChartData.filter(x => x.value === 0).length === this.supplierChartData.length) {
                    this.noProposals = true;
                }
            } else {
                this.noProposals = true;
            }
        });
    }

    goToPEProposal(event: any) {
        if (event.id === ChartProposalStatus.Pending) {
            this.router.navigate(['/Pendingproposals']);
        }

        if (event.id === ChartProposalStatus.Rejected) {
            this.router.navigate(['/Rejectedproposals']);
        }
    }

    getSummaryForPE() {
        this.chartSpinner = true;
        this.dataService.getSummaryForPE().subscribe((response: any) => {
            this.chartSpinner = false;
            if (response != null) {
                this.noProposals = false;
                this.summaryForPEDTO = response.Data;
                this.peChartData = [
                    {
                        label: 'To be Reviewed',
                        value: this.summaryForPEDTO.Submitted || 0,
                        id: ChartProposalStatus.Submitted
                    },
                    {
                        label: 'Rejected',
                        value: this.summaryForPEDTO.Rejected || 0,
                        id: ChartProposalStatus.Rejected
                    },
                    {
                        label: 'Approved',
                        value: this.summaryForPEDTO.Approved || 0,
                        id: ChartProposalStatus.Approved
                    }
                ];

                if (this.peChartData.filter(x => x.value === 0).length === this.peChartData.length) {
                    this.noProposals = true;
                }
            } else {
                this.noProposals = true;
            }
        });
    }

    ngAfterViewInit(): void { }
}
